var bundledVariants = [];

$(document).ready(function() {
	checkBundledVariants();
});

// Get bundled products on variant change to reduce impact on checkout speed.
$('#SingleOptionSelector-0').change(function() {
	console.log('option changed');
	checkBundledVariants();
});

$('#AddToCart-buttonV').click(function(event) {
	event.preventDefault();
    //console.log('step1');
	var productTitle = $('.product-single__title').text();

	var variantId = $('#ProductSelect-product-template').val();
  console.log('variantID'+variantId);
	var variantTitle = $('#ProductSelect-product-template option[value="'+variantId+'"]').data('title');
	var variantPrice = $('#ProductSelect-product-template option[value="'+variantId+'"]').data('price');

	var mainProduct = {
		quantity: 1,
		id: variantId,
		properties: {}
	}
	var Groupsell =  $('.selectedgroupsell').text();
    if(Groupsell != ''){
      var GroupsellProduct = {
    		quantity: 1,
    		id: Groupsell,
    		properties: {}
    	}
    	var itemsToAdd = [mainProduct,GroupsellProduct];
      console.log(Groupsell);
    }else{
      var itemsToAdd = [mainProduct];
    }

	// Pre-order properties
	if($('#preorderProperty').length) {
		var preorderProperty = $('#preorderProperty').val();
		mainProduct.properties[preorderProperty] = 1;
	}

	// Bundled product
	if(bundledVariants.length > 0) {

		var bundleId = Date.now();

		mainProduct.properties['Bundle ID'] = bundleId

		var bundleProduct = {
			quantity: 1,
			id: null,
			properties: {
				'Bundle ID': bundleId, // for Grouping
				'Bundled with': productTitle // for identifying bundled product
			}
		};

		if(Groupsell != ''){
        	var itemsToAdd = [mainProduct,GroupsellProduct];
        }else{
            var itemsToAdd = [mainProduct];
          }
		$.each(bundledVariants, function(key,val) {
			var product = { ...bundleProduct };
			product.id = val;

			itemsToAdd.unshift(product);
		});
        console.log(itemsToAdd);
	}
  
    
	var contentName = `${productTitle}`;
	if(variantTitle !== 'Default Title') contentName += ` - ${variantTitle}`;

	// FB Pixel
	var fbqObj = {
		content_name: contentName,
		content_category: meta.product.type,
		content_ids: [meta.product.id],
		content_type: 'product_group',
		value: variantPrice,
		num_items: 1,
		currency: 'AUD'
	};
	if(fbq) fbq('track', 'AddToCart', fbqObj);
	fbq = null;

	// Post to cart
	var params = {
		type: 'POST',
		url: '/cart/add.js',
		data: {items: itemsToAdd},
	    dataType: 'json',
		success: function(line_item) {
          console.log('added to cart');
			window.location.href = "/cart";
		},
		error: function(XMLHttpRequest, textStatus) {
			//window.location.reload();
			console.log('Error adding to cart');
			console.log(XMLHttpRequest);
			console.log(textStatus);
		}
	};
	$.ajax(params);

});

function checkBundledVariants() {
	bundledVariants = []; // Reset bundled variants
	var variantTitle = $('#SingleOptionSelector-0').val();

	// Get variant ID
	if(variantTitle) {
		var variantId = $('#ProductSelect-product-template option:contains("'+ variantTitle +'")').attr('value');
	} else {
		var variantId = $('#ProductSelect-product-template').val();
	}

	var $option = $('#ProductSelect-product-template option[value="'+variantId+'"]');

	// Check if bundled
	if($option.attr('data-bundled-variant-ids')) {
		var bundledVariantIds = $option.attr('data-bundled-variant-ids').split(',');

		// Updated bundled variants array
		$.each(bundledVariantIds, function(key,val) {
			if(val && val !== "0") bundledVariants.push(val);
		});
	}
}
